import { decodeTokenService } from "../services/decodeTokenService";

const getAllowedChatOwnerIds = () =>
  String(import.meta.env.VITE_ENABLED_CHAT_OWNER_IDS || "")
    .split(",")
    .map((ownerId) => ownerId.trim())
    .filter(Boolean);

export const isChatEnabledForOwner = (
  ownerId: string | null | undefined
): boolean => {
  if (!ownerId) return false;
  return getAllowedChatOwnerIds().includes(ownerId);
};

export const isChatEnabledForCurrentUser = (): boolean =>
  isChatEnabledForOwner(decodeTokenService.getUserIdFromToken());
